<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <button v-if="this.$store.getters.getLoggedInState && this.$store.getters.getSearchByState == 'verse'" class="btn btn-success save" @click="saveVerse">Save verse</button>
                    <label v-if="this.$store.getters.getCurrentPage == 'jesus'" class="versetab">{{ this.$store.getters.getEsvState ? 'ESV' : 'KJV' }}<span> - Jesus verse</span></label>
                    <label v-else class="versetab">{{ this.$store.getters.getEsvState ? 'ESV' : 'KJV' }}<span> - {{ this.$store.getters.getSearchByState == 'verse' ? 'verse' : 'verses' }}</span></label>
                    <div class="verse-cont">
                        <template v-if="this.$store.getters.getLoadingState">
                            <app-spinner></app-spinner>
                        </template>
                        <template v-else>
                            <div v-if="bookDetails === undefined || bookDetails.length == 0 ">
                                <p class="verse-message" v-if="this.$store.getters.getCurrentPage == 'jesus'">Choose a book and chapter/verse, then press View.</p>
                                <p class="verse-message" v-else>View by Chapter, by Verse or by a range of Verses. To view a range of verses from 1 to 10, type 1-10 in the input field.</p>
                            </div>
                            <div v-else>
                                <template v-if="this.$store.getters.getSearchByState == 'verse'">
                                    <div v-for="(bookDetail, i) in bookDetails" :key="i">
                                        <div class="verse-item">
                                            <h4 v-if="i == 0">{{ bookDetails[i].bookName }}</h4>
                                            <blockquote>
                                            <h5>{{ bookDetail.chapterAndVerse }}</h5>
                                            <p v-html="bookDetail.verseText">{{ bookDetail.verseText }}</p>
                                            </blockquote>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-for="(bookDetail, i) in bookDetails" :key="i">
                                        <div class="verse-item">
                                            <h4 v-if="i == 0">{{ bookDetails[i].bookName }}</h4>
                                            <span>{{ bookDetail.chapterAndVerse }}</span>
                                            <p class="inline" v-html="bookDetail.verseText">{{ bookDetail.verseText }}</p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Spinner from '../components/UI/Spinner.vue';
    
    export default {
        props: ['bookDetails'],
        methods: {
            saveVerse() {
                this.$parent.saveVerseDetails();
            }
        },
        components: {
            appSpinner: Spinner
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/VerseDetail.vue